import React, { useContext, useState } from "react";
import "./shop.css";
import { ServerContext } from "../../contex/ServerContext";
import { Navbar, Nav, Form, FormControl, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { IMG_URL } from "../../constants";

function Shop() {
  const { get } = useContext(ServerContext);
  const [getValue] = get;

  const [searchTerm, setSearchTerm] = useState("");

  return (
    <div className="Shop">
      <div className="shop_header">
        <div
          className="container"
          style={{ fontSize: "20px", fontFamily: "-moz-initial" }}
        >
          <b>Shop</b>
          <br />
          <p style={{ paddingTop: "10px" }}>Home/Shop</p>
        </div>
      </div>
      <div className="items container ">
        <div className="categories">
          <h4>Categories:</h4>
          <div style={{ marginLeft: "25px" }}>
            <Navbar collapseOnSelect expand="lg">
              <Navbar.Toggle
                aria-controls="navbarScroll"
                style={{ backgroundColor: "#f3f3f3" }}
              />
              <Navbar.Collapse id="responsive-navbar-nav">
                <Nav className="ml-auto">
                  <ul>
                    <br />
                    <Link
                      to="/man"
                      style={{ color: "black", textDecoration: "none" }}
                    >
                      <li>Man</li>
                    </Link>
                    <Link
                      to="/Woman"
                      style={{ color: "black", textDecoration: "none" }}
                    >
                      <li>Woman</li>
                    </Link>
                  </ul>
                </Nav>
              </Navbar.Collapse>
            </Navbar>
          </div>
        </div>
        <div style={{ paddingBottom: "15px" }}>
          <div className="shop_img px-3 ">
            <Form className="d-flex  ">
              <FormControl
                type="search"
                placeholder="Search Dress"
                onChange={(event) => {
                  setSearchTerm(event.target.value);
                }}
                className="mr-2"
                aria-label="Search"
              />
            </Form>
            <br />
            <div className="d-grid gap-2">
              <Button variant="dark" size="lg">
                Search
              </Button>
            </div>
          </div>
          {/* <img className="shop_img" src={MW} alt="" /> */}
        </div>
        {getValue
          .filter((val) => {
            if (searchTerm === "") {
              return val;
            } else if (
              val.name.toLowerCase().includes(searchTerm.toLocaleLowerCase())
            ) {
              return val;
            }
            return false;
          })
          .map((get) => {
            return (
              <div className="item">
                <Link
                  to={`/ItemDetails/${get._id}`}
                  style={{ textDecoration: "none" }}
                >
                  {/* <ItemDetails item={get} /> */}
                  <img
                    src={IMG_URL + get.image}
                    width="250px"
                    height="250px"
                    alt=""
                  />
                  <br />
                  <div className="text-center text-dark py-3 ">
                    <b>{get.name}</b>
                  </div>
                </Link>
              </div>
            );
          })}
      </div>
    </div>
  );
}

export default Shop;
